/**
 * ForgotPasswordForm
 *
 */

// TODO fix handler names
/* eslint-disable react/jsx-handler-names */

import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { NVMonitor } from '@nv/react-commons/src/Components'
import { ApiHelper } from '@nv/react-commons/src/Services'
import { SelectorUtils } from '@nv/react-commons/src/Utils'
import PropTypes from 'prop-types'
import { DialogBox } from 'components/DialogBox'
import dashApi from 'services/api/dashApi'
import injectSaga from 'utils/injectSaga'

import { userCreators } from '../Base/redux'
import saga from './saga'

const formMessages = {
  title: 'forgot_password_title',
  captions: ['forgot_password_caption'],
  email: 'email',
  errorLink: 'recover_email',
  submit: 'forgot_password_submit'
}
const successMessages = {
  title: 'check_email_title',
  captions: ['check_email_caption_1', 'check_email_caption_2', 'check_email_caption_3'],
  secondary: 'check_email_secondary'
}
const customErrors = {
  150002: null,
  150003: 'shipper_linked'
}

const { selector } = SelectorUtils

export class ForgotPasswordForm extends React.Component {
  state = {
    email: '',
    forgotPasswordSent: false
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const fp = nextProps?.user?.forgotPasswordSent
    if (fp && fp !== this.props?.user?.forgotPasswordSent) {
      this.setState({ forgotPasswordSent: fp })
    }
  }

  handleChange = values => {
    this.setState(values)
  }

  handleSubmit = data => {
    const type = this.props.addShipper ? 'AddShipper' : 'ResetPassword'
    const params = data || this.props.user.forgotPasswordData
    return this.props.forgotPassword({ ...params, type })
  }

  render () {
    const messages = this.state.forgotPasswordSent ? successMessages : formMessages
    const { email } = this.state
    return (
      <>
        <NVMonitor monitor='forgotPassword' customErrors={customErrors} onError={this.props.forgotPasswordFailure} />
        <DialogBox
          {...this.props}
          values={{ email }}
          onChange={this.handleChange}
          action={this.handleSubmit}
          messages={messages}
          secondaryAction={data => this.action(data)}
        />
      </>
    )
  }
}

ForgotPasswordForm.propTypes = {
  forgotPassword: PropTypes.func,
  addShipper: PropTypes.func,
  user: { forgotPasswordData: PropTypes.any },
  forgotPasswordFailure: PropTypes.func
}

const mapStateToProps = createStructuredSelector({
  error: selector('global', 'user', 'error')(),
  user: selector('global', 'user', 'data')()
})

function mapDispatchToProps (dispatch) {
  return {
    forgotPassword: data => dispatch(ApiHelper.creators.request('forgotPassword', dashApi.forgotPassword, [data])),
    forgotPasswordFailure: error => dispatch(userCreators.forgotPasswordFailure(error)),
    dismissError: () => dispatch(userCreators.clearError())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSaga = injectSaga({ key: 'forgotPasswordForm', saga })

export default compose(withSaga, withConnect)(ForgotPasswordForm)
